import { useCopilotContext } from '@customerio/hydra-copilot/react';
import { ShowPremiumUpgradeFormTool } from './tools/account-management-tool';
import { AskUserQuestionTool } from './tools/ask-user-question';
import { BashTool } from './tools/bash';
import { CronTool } from './tools/cron';
import { ShowFeedbackTool } from './tools/feedback-tool';
import { ShowSupportFormTool } from './tools/support-tool';

/**
 * Adds global configuration to the Copilot context.
 */
export function GlobalCopilotConfiguration() {
  useCopilotContext({
    description: 'The current URL',
    value: window.location.href,
  });

  useCopilotContext({
    description: 'The current URL title',
    value: document.title,
  });

  useCopilotContext({
    description: 'The current timezone',
    value: Intl.DateTimeFormat().resolvedOptions().timeZone,
  });

  useCopilotContext({
    description: 'The current time',
    value: () => new Date().toISOString(),
  });

  return (
    <>
      <AskUserQuestionTool />
      <BashTool />
      <ShowPremiumUpgradeFormTool />
      <CronTool />
      <ShowFeedbackTool />
      <ShowSupportFormTool />
    </>
  );
}
